export default __webpack_public_path__ + "static/Pardot-e5d27c6f2d1fef4e2cd6ea7ac084c785.png";